export const countryValues = {
	id: 0,
	name: "",
	description: "",
	published: false,
};
